{
  "title": "VIP Cashback",
  "yourLevel": "СІЗДІҢ ДЕҢГЕЙІҢІЗ",
  "completed": "АЯҚТАЛДЫ",
  "locked": "ЖАБЫҚ",
  "xpLabel": "Тәжірибе",
  "xpRule": "Тәжірибе есебі: €1 ставка = {{xp}} тәжірибе ұпайы",
  "cashback": "Кешбэк {{pct}}%",
  "cashbackMax": "Кешбэк {{lo}}% - {{hi}}%",
  "daily": "Күнделікті",
  "everyDays": "{{days}} күнде бір рет",
  "active": "Белсенді: AZN {{amount}}",
  "claim": "АЛУ",
  "howTitle": "Бұл қалай жұмыс істейді?",
  "how1": "Сүйікті слот пен ойындарды ойнаңыз",
  "how2": "Тәжірибе жинап деңгейіңізді көтеріңіз",
  "how3": "Кешбэк пен сыйлық алыңыз",
  "lockedNote": "«{{name}}» деңгейіне жету үшін көбірек тәжірибе керек",
  "loginHint": "XP, кешбэк және алу үшін кіріңіз",
  "login": "Кіру",
  "history": "Тарих",
  "historyEmpty": "Жазба жоқ.",
  "claimTitle": "Кешбэк алу",
  "claimAmount": "Сома: {{amount}} AZN",
  "claimNote": "Нақты балансқа. Wagering: 0x.",
  "cancel": "Болдырмау",
  "confirm": "Растау",
  "congrats": "Құттықтаймыз!",
  "newLevel": "Жаңа VIP деңгей: {{name}}",
  "continue": "Жалғастыру",
  "infoBody": "Тек нақты ақшалы казино ставкалары XP мен кешбэк береді. Бонус, спорт және демо кірмейді. 24 сағат күту және мин 1 AZN.",
  "close": "Жабу",
  "maxNote": "VIP MAX — XP тоқтайды. Санат айналымы бойынша кешбэк.",
  "level_1": "Мыс",
  "level_2": "Қола",
  "level_3": "Күміс",
  "level_4": "Алтын",
  "level_5": "Яқут",
  "level_6": "Сапфир",
  "level_7": "Алмаз",
  "level_8": "VIP MAX",
  "maintenance": "Техникалық үзіліс — алу уақытша жабық.",
  "rulesTitle": "QAYDALAR",
  "rulesIntro": "“VIP Cashback” Kazinosuna xoş gəlmisiniz! Sistem səviyyənizə, oyun növlərinə və mərc müntəzəmliyinə görə real pulun bir hissəsini geri almaq imkanı verir. Nə qədər aktiv oynasanız, bir o qədər tez-tez və daha çox keşbek əldə edirsiniz.",
  "rulesWhatTitle": "VIP Cashback nədir",
  "rulesWhat": "Keşbek — oyun aktivliyinə görə xərclənmiş vəsaitin bir hissəsinin geri qaytarılmasıdır. Dinamikdir və səviyyəniz yüksəldikcə dəyişir.",
  "rulesLevelsTitle": "Cashback səviyyələri",
  "rulesLevels1": "Sistemdə 8 səviyyə var. Növbəti səviyyəyə keçmək üçün təcrübə xalı toplamaq lazımdır.",
  "rulesLevels2": "Yeni səviyyə keşbek faizini və götürmə tezliyini artırır.",
  "rulesXpTitle": "Təcrübə xalının hesablanması",
  "rulesXpNote": "Hər səviyyədə €1 mərc = müvafiq XP. Saytda balans və keşbek AZN-dir; XP əmsalları eyni qaydada tətbiq olunur (1 AZN mərc = eyni XP).",
  "rulesCbTitle": "Cashback necə işləyir",
  "rulesCb1": "1–7 səviyyələrdə (Mis–Almaz) keşbek uduzulmuş mərclərə görə hesablanır.",
  "rulesCbFormula": "Keşbek = (Mərclərin cəmi − Qazanılan məbləğ) × keşbek %",
  "rulesCb2": "Dövr üzrə nəticə müsbətdirsə, keşbek 0 olur.",
  "rulesCb3": "VIP MAX-da keşbek hər real mərcə görə kateqoriya faizi ilə verilir: Slot 0.25%, Lotereya 0.20%, Canlı kazino 0.10%, Masa oyunları 0.05%.",
  "rulesImportantTitle": "Bilmək vacibdir",
  "rulesImportant1": "Bonus balanslı, idman və demo mərclər XP/keşbek yaratmır.",
  "rulesImportant2": "24 saat gözləmə və minimum 1 AZN götürmə qaydası qüvvədədir.",
  "rulesImportant3": "Keşbek birbaşa real balansa köçürülür (0x wagering).",
  "rulesXp1": "1-ci səviyyə “Mis”: Hər €1 mərc üçün oyunçu 100 təcrübə xalı alır",
  "rulesXp2": "2-ci səviyyə “Bürünc”: Hər €1 mərc üçün oyunçu 150 təcrübə xalı alır",
  "rulesXp3": "3-ci səviyyə “Gümüş”: Hər €1 mərc üçün oyunçu 200 təcrübə xalı alır",
  "rulesXp4": "4-ci səviyyə “Qızıl”: Hər €1 mərc üçün oyunçu 250 təcrübə xalı alır",
  "rulesXp5": "5-ci səviyyə “Yaqut”: Hər €1 mərc üçün oyunçu 300 təcrübə xalı alır",
  "rulesXp6": "6-ci səviyyə “Safir”: Hər €1 mərc üçün oyunçu 350 təcrübə xalı alır",
  "rulesXp7": "7-ci səviyyə “Almaz”: Hər €1 mərc üçün oyunçu 400 təcrübə xalı alır",
  "rulesXp8": "8-ci səviyyə “VIP MAX”: sonuncu səviyyə, təcrübə xalı verilmir",
  "lockedShort": "ЖАБЫҚ"
}
